<template>
<div>
    <div class="bg-gradient"></div>
    <div class="main-page">
        <div class="container-fluid">
            <div class="row">
                <div class="d-flex today-calls" style="" >
                    <div class="">
                        <span class="count-title d-block mb-fix">Today’s Calls</span>
                        <router-link class="count d-block" :class="GetEnquiriesCount === 0 ? 'disabled' : ''" :to="{ name: 'Today', params: {page: 'brokers', callType: 'todays_calls', meetingExecutiveId: $route.params.meeting_executive_ids, advancedSearch: $route.params.is_advanced_search } }">{{ GetEnquiriesCount }}</router-link>
                    </div>
                    <div class="">
                        <span class="count-title d-block mb-fix">Backlog</span>
                        <router-link class="count d-block" :class="backLogData === 0 ? 'disabled' : ''" :to="{ name: 'Today', params: { page: 'brokers', callType: 'backlog_calls' } }">{{ backLogData }}</router-link>
                    </div>
                </div>
                <div class="col-12">
                    <div class="search-holder mt-30 search-holder-list">
                        <div class="input-group">
                            <input type="text" placeholder="Search by Title" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                            <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close">
                                <g>
                                    <g>
                                        <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z" />
                                    </g>
                                </g>
                            </svg>
                            <div class="input-group-append align-fix" id="button-addon4">
                                <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                                        <g>
                                            <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                        </g>
                                    </svg>
                                </button>
                                <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                                    <img src="@/assets/filter.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                        </div>
                    </div>
                </div>
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card enquiry-card m-height">
                        <b-list-group class="list-group-flush">
                            <b-list-group-item :to="{ name: 'CPBrokerDetails', params: {  brokerid: item.id }}" v-for="item in brokerList" :key="item.id">
                                <div class="row">
                                    <div class="col-8 pr-1">
                                        <span class="name" v-if="item.name">{{item.name}} - {{item.firm_name}}</span>
                                        <span class="project-name " v-if="item.locality_name">{{item.locality_name}}</span>
                                    </div>
                                    <div class="col-4 pl-1 text-right">
                                        <span class="label-tag" v-if="item.status">{{item.status}}</span>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <!-- <router-link to="/AddMeeting" class="float-btn"><img src="@/assets/plus.svg" alt=""></router-link> -->
            <div class="pagination-holder">
                <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :page-class="'page-item'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'" :disabled-class="'page-item disabled'" :container-class="'pagination justify-content-center'">
                </paginate>
            </div>
            <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow>
                <template v-slot="{ hide }">
                    <div class="card form-card sidebar-form-card">
                        <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                            <b-form-group>
                                <b-form-input type="text" v-model="AdvancedFilterBroker.name" placeholder="Name"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="text" v-model="AdvancedFilterBroker.firm_name" placeholder="Firm Name"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="email" v-model="AdvancedFilterBroker.email" placeholder="Email Address"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="text" v-model="AdvancedFilterBroker.contact_number" placeholder="Contact Number" minlength="10"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Empanelment Date From">
                                <datetime type="date" v-model="AdvancedFilterBroker.empanelment_date_from" placeholder="Empanelment Date from"></datetime>
                            </b-form-group>
                            <b-form-group label="Empanelment Date Upto">
                                <datetime type="date" v-model="AdvancedFilterBroker.empanelment_date_upto" placeholder="Empanelment Date Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="Next Call Date From">
                                <datetime type="date" v-model="AdvancedFilterBroker.next_call_date_from" placeholder="Next Call Date From"></datetime>
                            </b-form-group>
                            <b-form-group label="Next Call Date Upto">
                                <datetime type="date" v-model="AdvancedFilterBroker.next_call_date_upto" placeholder="Next Call Date Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="Meeting Scheduled From">
                                <datetime type="date" v-model="AdvancedFilterBroker.meeting_scheduled_from" placeholder="Meeting Scheduled From"></datetime>
                            </b-form-group>
                            <b-form-group label="Meeting Scheduled Upto">
                                <datetime type="date" v-model="AdvancedFilterBroker.meeting_scheduled_upto" placeholder="Meeting Scheduled Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="Last Meeting Date From">
                                <datetime type="date" v-model="AdvancedFilterBroker.last_meeting_date_from" placeholder="Last Meeting Date From"></datetime>
                            </b-form-group>
                            <b-form-group label="Last Meeting Date Upto">
                                <datetime type="date" v-model="AdvancedFilterBroker.last_meeting_date_upto" placeholder="Last Meeting Date Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="">
                                <multiselect v-model="AdvancedFilterBroker.affiliate_filter" :searchable="true" placeholder="Affiliate Filter" label="text" class="form-multiselect" track-by="value" :options="affiliateList" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="">
                                <multiselect v-model="AdvancedFilterBroker.loan_mou_uploaded" :searchable="true" placeholder="Is Loan MOU Uploaded" label="text" class="form-multiselect" track-by="value" :options="loanMOUUploads" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.crm_statuses" :searchable="true" placeholder="Select Status" label="text" class="form-multiselect" ref="brokerselect" track-by="value" :options="crmStatuses" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.sub_status_ids" :searchable="true" placeholder="Select Sub Status" label="name" class="form-multiselect" track-by="id" :options="settingsList.sub_status_data" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.localities" :searchable="true" placeholder="Select Localities" label="text" class="form-multiselect" track-by="value" :options="settingsList.localities" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.performance" :searchable="true" placeholder="Select Performance" label="text" class="form-multiselect" track-by="value" :options="settingsList.performance" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.categorization" :searchable="true" placeholder="Select Categorization" label="text" class="form-multiselect" track-by="value" :options="settingsList.categorization" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.meeting_executive_ids" :searchable="true" placeholder="Select Meeting Executives" label="text" class="form-multiselect" track-by="value" :options="settingsList.field_executives" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.tl_id" :searchable="true" placeholder="Select TL" label="text" class="form-multiselect" track-by="value" :options="settingsList.tls" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.calling_executive_ids" :searchable="true" placeholder="Select Calling Executives" label="text" class="form-multiselect" track-by="value" :options="settingsList.calling_executives" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="">
                                <multiselect v-model="AdvancedFilterBroker.is_mou_uploaded" :searchable="true" placeholder="Is MOU Uploaded" label="text" class="form-multiselect" track-by="value" :options="IsMOUUploads" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.cities" :searchable="true" placeholder="Select Cities" label="text" class="form-multiselect" track-by="value" :options="settingsList.cities" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="" v-if="settingsList">
                                <multiselect v-model="AdvancedFilterBroker.kyc_statuses" :searchable="true" placeholder="Select KYC Statuses" label="text" class="form-multiselect" track-by="value" :options="settingsList.kyc_statuses" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group class="btn-fixed">
                                <b-button variant="primary" type="submit" block @click="hide">Search</b-button>
                                <b-button variant="primary-outline" block type="reset">Reset</b-button>
                            </b-form-group>
                        </b-form>
                    </div>
                </template>
            </b-sidebar>
        </div>
    </div>
</div>
</template>

<script>
import {
    paramsFromQuery,
    decodeCPBrokerSearchParams
} from "@/assets/scripts/utility.js";
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import qs from "qs";

export default {
    name: "Brokers",
    components: {
        datetime: Datetime,
        Multiselect
    },
    data() {
        return {
            brokerList: [],
            settingsList: null,
            Filter: this.$route.query.search_query,
            total: 0,
            perPage: 0,
            GetEnquiriesCount: 0,
            backLogData: 0,
            AdvancedFilterBroker: {
                name: null,
                firm_name: null,
                email: null,
                contact_number: null,
                next_call_date_from: null,
                next_call_date_upto: null,
                empanelment_date_from: null,
                empanelment_date_upto: null,
                meeting_scheduled_from: null,
                meeting_scheduled_upto: null,
                last_meeting_date_from: null,
                last_meeting_date_upto: null,
                affiliate_filter: false,
                loan_mou_uploaded: false,
                crm_statuses: [],
                sub_status_ids: [],
                localities: [],
                performance: [],
                categorization: [],
                meeting_executive_ids: [],
                tl_id: null,
                calling_executive_ids: [],
                is_mou_uploaded: false,
                cities: [],
                kyc_statuses: []
            },
            affiliateList: [{
                value: '',
                text: 'Affiliate Filter'
            }, {
                value: 'yes',
                text: 'Yes'
            }, {
                value: 'no',
                text: 'no'
            }],
            loanMOUUploads: [{
                value: '',
                text: 'Loan MOU Uploaded'
            }, {
                value: 'yes',
                text: 'Yes'
            }, {
                value: 'no',
                text: 'no'
            }],
            IsMOUUploads: [{
                value: '',
                text: 'MOU Uploaded'
            }, {
                value: 'yes',
                text: 'Yes'
            }, {
                value: 'no',
                text: 'no'
            }]
        }
    },
    created() {
        this.fetchBrokers();
        this.fetchMyCPSettings();
    },
    watch: {
        $route(to, from) {
            this.fetchBrokers();
        },
    },
    methods: {
        fetchBrokers() {
            let queryP = {}
            let advSearchParams;
            paramsFromQuery(queryP, this.$route.query);
            if (this.$route.query.is_advanced_search) {
                let searchParams = this.$route.query
                for (let key in searchParams) {
                    queryP[key] = searchParams[key];
                }
                advSearchParams = queryP
            }
            if (advSearchParams) {
                paramsFromQuery(queryP, advSearchParams);
            } else {
                paramsFromQuery(queryP, this.$route.query);
            }
            this.$axios.get(`brokers/my_cps`, {
                params: queryP,
                paramsSerializer: (params) =>
                    qs.stringify(params, {
                        arrayFormat: "brackets"
                    }),
            }).then((res) => {
                this.brokerList = res.data.brokers;
                this.GetEnquiriesCount = res.data.today_call_count;
                this.backLogData = res.data.back_log_count;
                // this.brokerList = res.data.campaigns;
                this.perPage = res.data.per_page;
                this.total = res.data.count;
            });
        },
        fetchMyCPSettings() {
            this.$axios.get('brokers/my_cps_settings')
                .then(res => {
                    this.settingsList = res.data;
                    if (this.settingsList) {
                        if (this.settingsList && this.settingsList.sourcing_crm_statuses) {
                            this.settingsList.sourcing_crm_statuses = this.settingsList.sourcing_crm_statuses.map(status => ({
                                ...status,
                                text: status.name,
                                value: status.id
                            }));
                            this.settingsList.sourcing_crm_statuses.unshift({
                                text: 'Select Status',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.non_sourcing_crm_statuses) {
                            this.settingsList.non_sourcing_crm_statuses = this.settingsList.non_sourcing_crm_statuses.map(status => ({
                                ...status,
                                text: status.name,
                                value: status.id
                            }));
                            this.settingsList.non_sourcing_crm_statuses.unshift({
                                text: 'Select Status',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.localities) {
                            this.settingsList.localities = this.settingsList.localities.map(locality => ({
                                ...locality,
                                text: locality.name,
                                value: locality.id
                            }));
                            this.settingsList.localities.unshift({
                                name: 'Select Localities',
                                id: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.performance) {
                            this.settingsList.performance = this.settingsList.performance.map(perf => ({
                                text: perf,
                                value: perf
                            }));
                            this.settingsList.performance.unshift({
                                text: 'Select Performance',
                                value: ''
                            });
                        }
                        // if (this.settingsList && this.settingsList.categorization) {
                        //     this.settingsList.categorization = this.settingsList.categorization.map(category => ({
                        //         text: category,
                        //         value: category
                        //     }));
                        //     this.settingsList.categorization.unshift({
                        //         text: 'Select Categorization',
                        //         value: ''
                        //     });
                        // }
                        if (this.settingsList && this.settingsList.categorization_can_change) {
                            this.settingsList.categorization_can_change = this.settingsList.categorization_can_change.map(category => ({
                                text: category,
                                value: category
                            }));
                            this.settingsList.categorization_can_change.unshift({
                                text: 'Select Categorization',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.field_executives) {
                            this.settingsList.field_executives = this.settingsList.field_executives.map(executive => ({
                                ...executive,
                                text: executive.full_name,
                                value: executive.id
                            }));
                            this.settingsList.field_executives.unshift({
                                text: 'Select Executive',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.calling_executives) {
                            this.settingsList.calling_executives = this.settingsList.calling_executives.map(executive => ({
                                ...executive,
                                text: executive.full_name,
                                value: executive.id
                            }));
                            this.settingsList.calling_executives.unshift({
                                text: 'Select Executive',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.tls) {
                            this.settingsList.tls = this.settingsList.tls.map(executive => ({
                                ...executive,
                                text: executive.full_name,
                                value: executive.id
                            }));
                            this.settingsList.tls.unshift({
                                text: 'Select TL',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.cities) {
                            this.settingsList.cities = this.settingsList.cities.map(city => ({
                                ...city,
                                text: city.name,
                                value: city.id
                            }));
                            this.settingsList.cities.unshift({
                                text: 'Select City',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.kyc_statuses) {
                            this.settingsList.kyc_statuses = Object.keys(res.data.kyc_statuses).map(kyc => ({
                                text: kyc,
                                value: res.data.kyc_statuses[kyc]
                            }));
                            this.settingsList.kyc_statuses.unshift({
                                text: 'Select KYC Status',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.kyc_statuses) {
                            this.settingsList.kyc_statuses = Object.keys(res.data.kyc_statuses).map(kyc => ({
                                text: kyc,
                                value: res.data.kyc_statuses[kyc]
                            }));
                            this.settingsList.kyc_statuses.unshift({
                                text: 'Select KYC Status',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.categorization) {
                            this.settingsList.categorization = Object.keys(res.data.categorization).map(category => ({
                                text: category,
                                value: res.data.categorization[category]
                            }));
                            this.settingsList.categorization.unshift({
                                text: 'Select Categorization',
                                value: ''
                            });
                        }
                        if (this.settingsList && this.settingsList.sub_status_data) {
                            this.settingsList.sub_status_data = res.data.sub_status_data
                            this.settingsList.sub_status_data.unshift({
                                name: 'Select Sub Status',
                                id: ''
                            });
                        }
                    }
                    this.$store.dispatch('setCPSettings', res.data);
                }).catch(err => console.log(err.response));
        },
        AdvancedFilter() {
            const sendData = decodeCPBrokerSearchParams(this.AdvancedFilterBroker);
            let newQ = {
                ...sendData,
                is_advanced_search: true
            };
            this.$router.replace({
                query: newQ
            });
            localStorage.setItem("urlParams", JSON.stringify(newQ));
            console.log(newQ,"new query")
        },
        resetAdvancedFilter() {
            this.AdvancedFilterBroker = {
                name: null,
                firm_name: null,
                email: null,
                contact_number: null,
                next_call_date_from: null,
                next_call_date_upto: null,
                empanelment_date_from: null,
                empanelment_date_upto: null,
                meeting_scheduled_from: null,
                meeting_scheduled_upto: null,
                last_meeting_date_from: null,
                last_meeting_date_upto: null,
                affiliate_filter: false,
                loan_mou_uploaded: false,
                crm_statuses: [],
                sub_status_ids: [],
                localities: [],
                performance: [],
                categorization: [],
                meeting_executive_ids: [],
                tl_id: null,
                calling_executive_ids: [],
                is_mou_uploaded: false,
                cities: [],
                kyc_statuses: []
            };
            let rQ = this.$route.query
            if (rQ.is_advanced_search) {
                this.$router.replace({
                    query: {}
                });
            }
            localStorage.removeItem("urlParams");
        },
        resetFilter() {
            let rQ = this.$route.query;
            this.Filter = "";
            if (rQ.search_query) {
                let {
                    search_query,
                    ...newQ
                } = rQ;
                this.$router.replace({
                    query: newQ
                });
                localStorage.setItem("urlParams", JSON.stringify(newQ));
            }
        },
        FilterData() {
            if (this.Filter) {
                let newQ = {
                    ...this.$route.query,
                    search_query: this.Filter
                };
                this.$router.replace({
                    query: newQ
                });
                localStorage.setItem("urlParams", JSON.stringify(newQ));
            }
        },
        goToPage(pageNo) {
            let newQ = {
                ...this.$route.query,
                pageNo
            };
            this.$router.replace({
                query: newQ
            });
            localStorage.setItem("urlParams", JSON.stringify(newQ));
        }
    },
    computed: {
        totalPages() {
            if (this.total === 0 || this.perPage === 0) {
                return 0;
            } else {
                return Math.ceil(this.total / this.perPage);
            }
        },
        pageNo: {
            get() {
                let pageNo = this.$route.query.pageNo || 1
                return parseInt(pageNo);
            },
            set() {
                true;
            }
        },
        pageStart() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
        },
        pageEnd() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.min(this.total, this.pageNo * this.perPage))
        },
        crmStatuses() {
            return localStorage.getItem('radiate-user-sourcing') === 'true' ? this.settingsList.sourcing_crm_statuses : this.settingsList.non_sourcing_crm_statuses;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style><style scoped>
.today-calls {
    width: 100%;
    justify-content: space-between;
    padding: 0 15px;
}
</style>
